/**
 * This function resets the focus to either last of first focusable elements within a node.
 *
 * @param {object} focusableEls - contains the first last of first focusable elements within a node.
 * @param {object} event - the triggered event
 */export var resetFocus=function(a){var b=a.focusableEls,c=b.first,d=b.last,e=a.event,f=document,g=f.activeElement;e.shiftKey&&g===c&&(d&&d.focus(),e.preventDefault()),e.shiftKey||g!==d||(c&&c.focus(),e.preventDefault())};